import {
  REQUEST_GET_MAPPING_LAWYERS,
  REQUEST_SET_MAPPING_LAWYERS,
  REQUEST_CREATE_INTERVENANT_KEYCLOAK,
  REQUEST_UPDATE_MAPPING_LAWYERS,
  REQUEST_SEARCH_MAPPING_LAWYERS,
  REQUEST_GET_MAPPING_LAWYER,
  REQUEST_SET_MAPPING_LAWYER,
} from 'containers/IntervenantManagement/constants';

export const requestGetMappingLawyers = (page: number, pageSize: number) => {
  return {
    type: REQUEST_GET_MAPPING_LAWYERS,
    page,
    pageSize,
  };
};

export const setMappingLawyers = (payload: any) => {
  return {
    type: REQUEST_SET_MAPPING_LAWYERS,
    payload,
  };
};

export const requestCreateIntervenantKeycloak = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_CREATE_INTERVENANT_KEYCLOAK,
    payload,
    successCallBack,
  };
};

export const requestUpdateMappingLawyers = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_UPDATE_MAPPING_LAWYERS,
    payload,
    successCallBack,
  };
};

export const requestSearchMappingLawyers = (payload: any) => {
  return {
    type: REQUEST_SEARCH_MAPPING_LAWYERS,
    payload,
  };
};

export const requestGetMappingLawyer = (payload: any) => {
  return {
    type: REQUEST_GET_MAPPING_LAWYER,
    payload,
  };
};

export const setMappingLawyer = (payload: any) => {
  return {
    type: REQUEST_SET_MAPPING_LAWYER,
    payload,
  };
};
